(function (root) {
    /*
     * If the root is not defined we're probably testing. Define some fake data.
     */
    if (!root) {
        root = new Object();
        root.staticData = {
            urls: {
                termsOfUseUrl: 'http://www.google.com'
            },
            currentTheme: null
        }
    } else if (!root.staticData) {
        root.staticData = {
            urls: {
                termsOfUseUrl: 'http://wwww.google.com'
            },
            currentTheme: null
        };
    }

    root.$angularApp = root.angular.module('SSOBroker', ['SumTotalComponents', 'ngMessages'])
      .config(['$provide', '$logProvider', '$themeProvider', function ($provide, $logProvider, $themeProvider) {
          /**
            * Handle extending the $log service...
            *
            * What is done here is to make sure that any logging statements within our code do not log to the console
            * sensitive information. Only the first statement, the message, will be passed through when in production.
            */
          $provide.decorator('$log', ['$delegate', function ($delegate) {

              var originalMethods = {
                  debug: $delegate.debug,
                  error: $delegate.error,
                  warn: $delegate.warn,
                  info: $delegate.info
              };

              $delegate.debug = function () {
                  if (staticData.debugEnabled) {
                      originalMethods.debug.apply(null, arguments);
                  }
              };

              $delegate.info = function () {
                  if (staticData.debugEnabled) {
                      originalMethods.info.apply(null, arguments);
                  }
              };

              $delegate.error = function () {
                  if (staticData.debugEnabled) {
                      originalMethods.error.apply(null, arguments);
                  } else {
                      var args = [arguments[0]];
                      originalMethods.error.apply(null, args);
                  }
              };

              $delegate.warn = function () {
                  if (staticData.debugEnabled) {
                      originalMethods.warn.apply(null, arguments);
                  } else {
                      var args = [arguments[0]];
                      originalMethods.warn.apply(null, args);
                  }
              };

              return $delegate;
          }]);

          /*
            * Sets up the theming provider.
            */
          if (root.staticData && root.staticData.currentTheme) {
              angular.extend($themeProvider.themeTemplate, root.staticData.currentTheme);
              $themeProvider.setCurrentTheme();
          }
      }])
      .controller('GlobalController', ['$scope', '$log', '$window', function ($scope, $log, $window) {
          /**
            * When invoked shows the terms of use window.
            */
          $scope.showTermsOfUse = function () {
              var width = 800;
              var height = 600;
              var left = ($window.screen.width / 2) - (width / 2);
              var top = ($window.screen.height / 2) - (height / 2);
              $log.debug('Terms of Use URL:', root.staticData.urls.termsOfUseUrl);
              var targetWin = $window.open(root.staticData.urls.termsOfUseUrl,
                "TermsOfUse",
                "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
          };
    }])
    .controller('attController', ['$scope', function ($scope) {
      $scope.isSigned = false;
    }])
    .directive('onSumtClickValidation', function () {
      return function (scope, element, attrs) {
        element.on('click', (function (event) {
          if (!scope.isSigned) {
            if (attrs.selectedvalue == '1') {
              event.preventDefault();
              alert(attrs.onSumtClickValidation);
            }
          }
        }));
      };
    })
    .directive('sumtTextbox', function () {
      return function (scope, element, attrs) {
          scope.$watch('signature', function (val) {
              if (attrs.issupportedbrowser == 0 && scope.signature == attrs.placeholder) {
                  scope.isSigned = false;
              }
              else if (scope.signature && scope.signature != '') {
                  scope.isSigned = true;
              }
              else {
                  scope.isSigned = false;
              }              
              var uiModeSelected = angular.element('#BodyContent_MainContent_hdnUIMode');              
              if (scope.signature && scope.signature != '') {
                  if (uiModeSelected && uiModeSelected[0]) {
                      if (uiModeSelected[0].value == "1") {
                          angular.element('#agreebtn').removeAttr('disabled');
                      }
                      else
                          if (uiModeSelected[0].value == "2") {
                              var agreeStatus = angular.element('#BodyContent_MainContent_ddlSelect');
                              if (agreeStatus && agreeStatus[0] && agreeStatus[0].value == "1") {
                                  angular.element('#btnSelectId').removeAttr('disabled');
                                  if (angular.element('#btnSelectId').hasClass('disabled'))
                                      angular.element('#btnSelectId').removeClass("disabled");                                      
                              }
                          }
                          else
                              if (uiModeSelected[0].value == "3") {
                                  var agreeStatus = angular.element('#BodyContent_MainContent_chkAgree');
                                  if (agreeStatus && agreeStatus[0] && agreeStatus[0].checked)
                                      angular.element('#btnCheckBoxId').removeAttr('disabled');
                              }
                              else
                                  if (uiModeSelected[0].value == "4") {
                                      var agreeStatus = angular.element('#BodyContent_MainContent_rdoAgree');
                                      if (agreeStatus && agreeStatus[0] && agreeStatus[0].checked)
                                          angular.element('#btnRadioId').removeAttr('disabled');
                          }
                                  else if (uiModeSelected[0].value == "5") {
                                    var chbxAgreeStatus = angular.element('#BodyContent_MainContent_ctl00');
                                    if (chbxAgreeStatus && chbxAgreeStatus[0] && chbxAgreeStatus[0].checked)
                                      angular.element('#agreebtn').removeAttr('disabled');
                                  }
                  }
              } else {
                  if (uiModeSelected && uiModeSelected[0]) {
                      if (uiModeSelected[0].value == "1" || uiModeSelected[0].value == "5") {
                          angular.element('#agreebtn').attr('disabled', '');
                      }
                      else
                          if (uiModeSelected[0].value == "2") {
                              var agreeStatus = angular.element('#BodyContent_MainContent_ddlSelect');
                              if (agreeStatus && agreeStatus[0] && agreeStatus[0].value == "1") {
                                  angular.element('#btnSelectId').attr('disabled', '');
                              }
                          }
                          else
                              if (uiModeSelected[0].value == "3") {
                                  var agreeStatus = angular.element('#BodyContent_MainContent_chkAgree');
                                  if (agreeStatus && agreeStatus[0] && agreeStatus[0].checked)
                                      angular.element('#btnCheckBoxId').attr('disabled', '');
                              }
                              else
                                  if (uiModeSelected[0].value == "4") {
                                      var agreeStatus = angular.element('#BodyContent_MainContent_rdoAgree');
                                      if (agreeStatus && agreeStatus[0] && agreeStatus[0].checked)
                                          angular.element('#btnRadioId').attr('disabled', '');
                                  }

                  }
              }
          });
        
        element.on('focus', (function (event) {
          if (attrs.issupportedbrowser == 0 && this.value == attrs.placeholder) {
            this.value = '';
            scope.isSigned = false;
          }
        }));
        element.on('blur', (function (event) {
          if (attrs.issupportedbrowser == 0 && this.value == '') {
            this.value = attrs.placeholder;
            scope.isSigned = false;
          }
        }));

        if (attrs.value) {
          scope.signature = attrs.value;
        }
      };
    });
}(this));
